import React from "react";
import {ColoredBox} from "../routes/course/ColoredBox";
import {THEME_DANGER} from "../styles/StyleConstants";
import {IoIosWarning} from "react-icons/io";

export function OBS({children}) {

    return (
        <div className={"my-3"}>
            <ColoredBox theme={THEME_DANGER} title={(
                <div className={"p-0 m-0 d-flex align-items-center"}>
                    <IoIosWarning className={"me-2"} size={24}/>
                    <h5 className={"p-0 m-0"}>OBS!</h5>
                </div>
            )}>
                {children}
            </ColoredBox>

        </div>


    );

}